import OptionsPanel from "./OptionsPanel"
import Color from "./Color"

export default class EdgeColor extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Edge Color" // TODO: This needs to be localized
    this.setting = "edgeColor"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
